import { BASE_PADRAO, baseDeIncidencia } from '@favo/core';

import { Valor } from '@/componentes/valor';
import type { BaseIncidencia, Despesas, PercentualComBase } from '@/dados';

import { Capitulo, Linha, NaoPreenchido } from './ficha';

/* As despesas variáveis e a fixa, com a base de incidência de cada percentual.
 *
 * A base sai de `baseDeIncidencia` do motor, com o padrão do próprio motor:
 * registro gravado sem a chave é lido de um jeito só, aqui e no cálculo. Foi
 * exatamente a divergência entre o que a tela mostrava e o que o motor lia que
 * gerou erro de R$ 39 mil num projeto de kit alto. */

const COMO_INCIDE: Record<BaseIncidencia, string> = {
  total: 'sobre o total',
  servico: 'sobre o serviço',
};

function Percentual({ campo, padrao }: { campo: PercentualComBase | null | undefined; padrao: BaseIncidencia }) {
  return (
    <>
      <Valor valor={campo?.valor} formato="percentual-pontos" tamanho="apoio" />
      <span className="text-tinta-2 text-nota"> {COMO_INCIDE[baseDeIncidencia(campo?.base, padrao)]}</span>
    </>
  );
}

export function DespesasDaEmpresa({ despesas }: { despesas: Despesas | null }) {
  const extras = (despesas?.extras ?? []).filter((extra) => extra?.nome);

  return (
    <Capitulo titulo="Despesas" descricao="Percentuais sobre a venda e a despesa fixa do mês.">
      {despesas === null ? (
        <NaoPreenchido>Nada preenchido na etapa Despesas.</NaoPreenchido>
      ) : (
        <div className="grid">
          <Linha rotulo="Comissão">
            <Percentual campo={despesas.comissao} padrao={BASE_PADRAO.comissao} />
          </Linha>
          <Linha rotulo="Carga tributária">
            <Percentual campo={despesas.tributo} padrao={BASE_PADRAO.tributo} />
          </Linha>
          <Linha rotulo="Outras">
            <Valor valor={despesas.outras} formato="percentual-pontos" tamanho="apoio" />
            <span className="text-tinta-2 text-nota"> {COMO_INCIDE.total}</span>
          </Linha>
          {extras.map((extra, indice) => (
            <Linha key={indice} rotulo={extra.nome ?? 'Extra'}>
              <Percentual campo={extra} padrao={BASE_PADRAO.extra} />
            </Linha>
          ))}
          <Linha rotulo="Despesa fixa mensal">
            <Valor valor={despesas.despFixa} formato="moeda" tamanho="apoio" />
          </Linha>
        </div>
      )}
    </Capitulo>
  );
}
